import React, { Fragment } from 'react'
import Logo from '../../_assets/images/logo.png'
import { Navbar, Container } from 'react-bootstrap'

import { useSelector } from 'react-redux'

export default function SetupLayout({ children }) {
  const alert = useSelector(state => state.alert);

  return (
    <Fragment>
      <Navbar id="navbar">
        <Navbar.Brand className="navbar-brand">
          <img src={Logo} alt="AxS Health Logo" height="30" className="d-line-block align-top" />
        </Navbar.Brand>
      </Navbar>
                      
    { alert.message &&
      <Container>
        <div className={`mt-4 alert ${alert.type}`}>{alert.message}</div>
      </Container>
    }

      { children }

      <footer className="footer">
        <div className="container my-auto">
          <div className="text-muted text-center">
            <div>
              AxS Health <small>v{process.env.REACT_APP_API_VERSION}</small>
            </div>
          </div>
        </div>
      </footer>
    </Fragment>
  )
}
